<template src="./template.html"></template>

<script>
  import PurchaseSummary from '@/components/modules/PurchaseSummary'

  export default {
    name: 'CartOverview',
    components: {
      PurchaseSummary,
    },
    props: {
      // index: Number,
      props: Object,
    },
  }
</script>
